var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 168,
    viewBox: "0 0 220 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 88,
    r: 80,
    fill: "#EBEBEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 26,
    cy: 28,
    r: 8,
    fill: "#E0E0E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 198,
    cy: 134,
    r: 6,
    fill: "#E0E0E1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 25,
    cy: 146,
    r: 10,
    fill: "#E0E0E1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 210,
    cy: 54,
    r: 10,
    fill: "#E0E0E1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 191,
    cy: 19,
    r: 7,
    fill: "#E0E0E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_52507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28.666,
    width: 138,
    height: 110,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 24,
    transform: "translate(41 28.666)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 53,
    cy: 40.666,
    r: 4,
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 66,
    cy: 40.666,
    r: 4,
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 79,
    cy: 40.666,
    r: 4,
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 71.666L69.5 81.166L60 90.666",
    stroke: "#E0E0E1",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8804 90.666H97.0804",
    stroke: "#E0E0E1",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_52507"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28.666,
    width: 138,
    height: 110,
    rx: 7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyQueue);
export default __webpack_public_path__ + "static/media/empty-queue.2a77e2e10fcdffc9d28db7bbbaf867df.svg";
export { ForwardRef as ReactComponent };